const MODULE_NAME = 'BubblesModule';

export const GET_BUBBLES = `${MODULE_NAME}/GET_BUBBLES`;
export const SAVE_BUBBLES = `${MODULE_NAME}/SAVE_BUBBLES`;
export const DELETE_BUBBLE = `${MODULE_NAME}/DELETE_BUBBLE`;
export const CREATE_BUBBLE = `${MODULE_NAME}/CREATE_BUBBLE`;
export const UPDATE_BUBBLE = `${MODULE_NAME}/UPDATE_BUBBLE`;
export const DELETE_BUBBLES = `${MODULE_NAME}/DELETE_BUBBLES`;
